import React from 'react';
import { Link } from 'react-router-dom'

import Banner from '../App/Banner';

import Sourire from '../../assets/sourire.png'

function Home() {
  return(
    <div id="welcome" className='wrap'>
      <Banner />

      <div id="welcome_banner">
        <h1>Bonjour et bienvenue sur notre simulateur de TVA pour les e-commerçants <img src={Sourire} alt="smiley" id='smiley' style={{padding: '0'}}/></h1>
        <p>Découvrez en quelques clics les spécificités de votre TVA et de sa déclaration, selon votre type d’activité.</p>
        <p>C’est parti !</p>
      </div>

      <div id="home" className='paper'>

        <h2>Votre stock se situe:</h2>
        <div className="select_container">
          <Link to='/France'><button className='select'>En France</button></Link>
          <Link to='/Europe'><button className='select'>En Union Européenne</button></Link>
          <Link to='/Hors-UE'><button className='select'>Hors Union Européenne <br /> <span id='subtitle'>
            (Dropshipping)</span></button></Link>
        </div>

      </div>
    </div>
  )
}

export default Home